import type { ActivityDataType } from '@/api/common';

export type ViewThroughVisitsDataType = Pick<
  ActivityDataType,
  | 'botViewThroughVisits'
  | 'botVisits'
  | 'otherViewThroughVisits'
  | 'otherVisits'
  | 'targetViewThroughVisits'
  | 'targetVisits'
  | 'unresolvedViewThroughVisits'
  | 'unresolvedVisits'
>;

export const VIEW_THROUGH_VISITS_METRIC_FIELDS = {
  target: 'targetViewThroughVisits',
  other: 'otherViewThroughVisits',
  bot: 'botViewThroughVisits',
  unresolved: 'unresolvedViewThroughVisits',
} as const;

export const getTotalVisits = (field: ViewThroughVisitsDataType) =>
  field.targetVisits + field.otherVisits + field.botVisits + field.unresolvedVisits;

export const getTotalViewThroughVisits = (field: ViewThroughVisitsDataType) =>
  Math.max(field.targetViewThroughVisits ?? 0, 0) +
  Math.max(field.otherViewThroughVisits ?? 0, 0) +
  Math.max(field.botViewThroughVisits ?? 0, 0) +
  Math.max(field.unresolvedViewThroughVisits ?? 0, 0);

export const getTotalVisitsWithViewThrough = (field: ViewThroughVisitsDataType) =>
  getTotalVisits(field) + getTotalViewThroughVisits(field);
